// extracted by mini-css-extract-plugin
export default {"MenuItem":"MenuItem_MenuItem__cgEaY","active":"MenuItem_active__3ZfqO"};